export default __webpack_public_path__ + "static/media/img_muslinTwoEarsBib_yg.1444a211.jpg";